import {TEMPLATE_SCRIPT_PATH, TEMPLATE_STYLE_PATH} from '../consts/publicStoragePaths';

const template = {
    styles: null,
    script: null,
};

const fetchTemplateFile = async (path, contentType) => {
    const response = await fetch(path, {
        headers: {
            Accept: contentType,
        },
    });

    const data = await response.text();

    // Server returns an HTML page instead of the template file if the file does not exist
    if (data.toLowerCase().includes('<!doctype html>')) {
        throw new Error(`${path} not found`);
    }

    return data;
};

const prepareCaptivePortalTemplate = async () => {
    const [script, styles] = await Promise.all([
        fetchTemplateFile(TEMPLATE_SCRIPT_PATH, 'application/javascript'),
        fetchTemplateFile(TEMPLATE_STYLE_PATH, 'text/css'),
    ]);

    template.script = script;
    template.styles = styles;
};

const getCaptivePortalTemplate = () => template;

export default {
    prepareCaptivePortalTemplate,
    getCaptivePortalTemplate,
};
